import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Charlottenburg() {
  return (
    <LocationPageTemplate
      page={{
        location: "Charlottenburg",
        locationSlug: "charlottenburg",
        keyword: "Haushaltsauflösung Charlottenburg",
        metaTitle:
          "Haushaltsauflösung Charlottenburg | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Haushaltsauflösung in Berlin Charlottenburg. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Charlottenburg – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eeb008498777f70b248.jpg",
        localIntro: (
          <>
            <p>
              Charlottenburg steht für großbürgerliches Wohnen in Berlin.
              Prächtige Gründerzeitbauten mit hohen Decken, weitläufige
              Wohnungen und ein oft hochwertiges Inventar prägen diesen Bezirk.
              Bei einer Haushaltsauflösung in Charlottenburg ist deshalb
              besondere Sorgfalt und Diskretion gefragt.
            </p>
            <p>
              Die logistischen Herausforderungen liegen oft in den klassischen
              Berliner Altbauten: Enge Treppenhäuser, fehlende Aufzüge in den
              Seitenflügeln und eine sehr angespannte Parkplatzsituation rund um
              den Kurfürstendamm oder den Savignyplatz erfordern eine exakte
              Planung.
            </p>
            <p>
              Wir haben jahrelange Erfahrung mit Räumungen in Charlottenburg.
              Unser Team geht mit dem Inventar und der Bausubstanz äußerst
              schonend um und sichert einen reibungslosen Ablauf – von der
              Beantragung der Halteverbotszone bis zur besenreinen Übergabe.
            </p>
          </>
        ),
        trustText:
          "Ob in einer herrschaftlichen Altbauwohnung nahe dem Savignyplatz oder einem Apartment in Westend – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen diskret zur Seite.",
        trustQuote:
          "Die Räumung der Wohnung meiner Tante in Charlottenburg wurde sehr respektvoll und professionell durchgeführt. Die Wertanrechnung war transparent und fair.",
        challengesText: (
          <>
            <p>
              In den belebten Straßen Charlottenburgs ist die Einrichtung einer
              Halteverbotszone unerlässlich. Wir kümmern uns im Vorfeld um alle
              Genehmigungen, um die Wege beim Abtransport so kurz wie möglich zu
              halten.
            </p>
            <p>
              Bei hochwertigen Nachlässen, die in Charlottenburg häufiger
              vorkommen, bieten wir eine faire Wertanrechnung an. Antiquitäten,
              Kunstgegenstände oder Schmuck können die Kosten der Entrümpelung
              deutlich reduzieren. Wir arbeiten dabei mit absoluter Diskretion,
              um die Privatsphäre unserer Kunden zu schützen.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Pünktlich, schnell und sehr sorgfältig. Das Treppenhaus wurde ohne Kratzer hinterlassen.",
            author: "Kunde aus Charlottenburg",
          },
          {
            text: "Die Wertanrechnung für die alten Möbel war sehr fair. Ein toller Service!",
            author: "Kundin aus Westend",
          },
          {
            text: "Absolut diskrete und professionelle Abwicklung. Die Wohnung war danach komplett besenrein.",
            author: "Familie nahe Kurfürstendamm",
          },
        ],
        neighbors: [
          { name: "Spandau", slug: "spandau" },
          { name: "Steglitz-Zehlendorf", slug: "steglitz-zehlendorf" },
          { name: "Berlin", slug: "berlin" },
        ],
        faqs: [
          {
            q: "Bieten Sie eine Wertanrechnung für Antiquitäten an?",
            a: "Ja, wir erkennen Wertgegenstände und rechnen diese transparent gegen die Kosten der Entrümpelung an.",
          },
          {
            q: "Kümmern Sie sich um das Halteverbot in Charlottenburg?",
            a: "Ja, wir übernehmen die komplette Beantragung beim Bezirksamt und stellen die Schilder auf.",
          },
          {
            q: "Was kostet eine Haushaltsauflösung in Charlottenburg?",
            a: "Die Kosten hängen vom Aufwand ab. Nach einer kostenlosen Besichtigung erhalten Sie von uns einen verbindlichen Festpreis.",
          },
          {
            q: "Räumen Sie auch Wohnungen im 5. Stock ohne Aufzug?",
            a: "Selbstverständlich. Wir räumen auch aus oberen Stockwerken ohne Aufzug und bringen dafür das nötige Personal mit.",
          },
        ],
      }}
    />
  );
}
